import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import eitsApi from '@/apis/eitsApi';
import LoginPageLayout from '@/views/Layout/LoginPageLayout.vue';

var Login = /*#__PURE__*/function (_Vue) {
  _inherits(Login, _Vue);

  var _super = _createSuper(Login);

  function Login() {
    var _this;

    _classCallCheck(this, Login);

    _this = _super.call(this);
    _this.notChromeIcon = [require('./../../assets/icons/notChromeIcon.svg')];
    _this.redirect = '';
    _this.checked = false;
    return _this;
  }

  _createClass(Login, [{
    key: "routerChange",
    value: function routerChange(route) {
      if (route.query) {
        this.redirect = route.query.redirect;
      }
    }
  }, {
    key: "forgetPwd",
    value: function forgetPwd() {
      this.$router.push({
        path: '/forgetPassword'
      });
    }
  }, {
    key: "loginBack",
    value: function loginBack(payload) {
      var _this2 = this;

      // console.log('loginBack', payload)
      var tokeList = payload.data.Authorization.split('#');

      if (payload.code === '200') {
        this.$store.dispatch('FedLogin', payload).then(function (_) {
          _this2.$router.push('/');
        });
      } else if (['1016', '1018', '1021', '1022'].includes(payload.code)) {
        this.$store.commit('SET_TOKEN', tokeList[0]);
        this.$store.commit('SET_CMTOKEN', tokeList[1]);
        var eitsLogin = this.$refs.eitsLogin;
        var logiInfo = {
          productCode: this.productCode,
          user: eitsLogin.user
        };
        this.$store.commit('SET_LOGIN_INFO', logiInfo); // console.log('页面跳转，修改密码')

        this.$router.push({
          name: 'ModifyPassword',
          params: {
            forceModifPwd: 'isWeak'
          }
        });
      } else {
        // console.log(payload);
        this.$message.error(payload.msg);
      } // if (payload.code === '200') {
      //   this.$store.dispatch('FedLogin', payload).then(_ => {
      //     this.$router.push('/');
      //   })
      // }

    }
  }, {
    key: "checkBack",
    value: function checkBack(payload) {
      console.log('checkBack', payload); // if (payload.type === "success") {
      //     this.$router.push({
      //         name: "home",
      //         params: {
      //             content: payload
      //         }
      //     });
      //     localStorage.setItem("eits-login-authorization", payload.token);
      // }
    }
  }, {
    key: "unableLogin",
    value: function unableLogin() {
      this.$message.error('请先阅读并同意《服务协议》和《隐私政策》');
    }
  }, {
    key: "verifyCodeUrl",
    get: function get() {
      return eitsApi.VERIFY_CODE_SDK;
    }
  }, {
    key: "challengeCodeUrl",
    get: function get() {
      return eitsApi.CHALLENGE_CODE_SDK;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return eitsApi.LOGIN_SDK;
    }
  }, {
    key: "productCode",
    get: function get() {
      return this.$store.getters.userInfo.productCode;
    }
  }, {
    key: "disableLoginPwdDialog",
    get: function get() {
      return true;
    }
  }, {
    key: "btnText",
    get: function get() {
      // if (this.isBtnLoading) return '登录中...';
      return '登录';
    }
  }, {
    key: "isChrome",
    get: function get() {
      // console.log('浏览器判断', navigator.userAgent)
      // console.log('浏览器判断 Chrome 内核', navigator.userAgent.indexOf('Chrome') > -1)
      // console.log('浏览器判断 Mobile 模式', navigator.userAgent.indexOf('Mobile') > -1)
      return navigator.userAgent.indexOf('Chrome') > -1 && !(navigator.userAgent.indexOf('Mobile') > -1);
    }
  }]);

  return Login;
}(Vue);

__decorate([Watch('$route', {
  immediate: true
})], Login.prototype, "routerChange", null);

Login = __decorate([Component({
  components: {
    LoginPageLayout: LoginPageLayout
  }
})], Login);
export default Login;